var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',{attrs:{"title":"Report","dark":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{attrs:{"id":"example1"}},[_c('p',[_vm._v("Download customized report")]),_vm._v(" "),_c('button',{staticClass:"btnPDF",on:{"click":_vm.fromHTML}},[_vm._v("\n\t\t\t\t\t\t\tPDF\n\t\t\t\t\t")])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34c22af5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewClient/Report.vue
// module id = null
// module chunks = 